<div class="product_table">
  <div class="product_header_section">
    <div style="font-size: 0.98vw; font-weight: 600">Prodcut Management</div>
    <div class="data_files">
      <button (click)="openInputForUpload()">
        <img src="../../assets/upload.png" alt="upload" /> Upload Data File
      </button>
      <input
        #productfileInput
        type="file"
        (change)="uploadCsv($event)"
        accept=".csv"
        style="display: none"
      />
      <button (click)="downloadSkuData('sku_data')">
        <img src="../../assets/download.png" alt="download" />
        Download Data File
      </button>
    </div>
  </div>
  <table
    [formGroup]="admin_product_dropdown_form_group"
    mat-table
    *ngIf="dataSource.data.length > 0"
    #mytable
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="sku_name">
      <th
        style="padding-left: 10px; width: 180px"
        mat-header-cell
        *matHeaderCellDef
      >
        <mat-form-field *ngIf="productNames.length > 0">
          <mat-label>Product Name </mat-label>
          <mat-select
            value="admin_product_dropdown_form_group['product_name'].value"
            formControlName="product_name"
            multiple
          >
            <mat-option (click)="toggleSelection(b,'product_name',0)" *ngFor="let b of productNames" [value]="b">{{
              b
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">
        {{ data.sku_name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="sku_image_uri">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Product Image
      </th>
      <td mat-cell *matCellDef="let data">
        <img style="height:120px;" alt="image" [src]="data.sku_image_uri" />
      </td>
    </ng-container>
    <ng-container matColumnDef="height_mm">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Height
      </th>
      <td mat-cell *matCellDef="let data">{{ data.height_mm.toFixed(1) }} mm</td>
    </ng-container>
    <ng-container matColumnDef="diameter_mm">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Width
      </th>
      <td mat-cell *matCellDef="let data">{{ data.diameter_mm.toFixed(1) }} mm</td>
    </ng-container>
    <!-- <ng-container matColumnDef="uf_name">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        <mat-form-field *ngIf="ufFlags.length > 0">
          <mat-label>UF Flag</mat-label>
          <mat-select
            value="admin_product_dropdown_form_group['uf_flag'].value"
            formControlName="uf_flag"
            (selectionChange)="onfilterChange(1, 'uf_flag')"
            multiple
          >
            <mat-option *ngFor="let b of ufFlags" [value]="b">{{
              b
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.uf_name }}</td>
    </ng-container> -->
    <ng-container matColumnDef="pack_type_revised">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        <mat-form-field *ngIf="packs.length > 0">
          <mat-label>Pack</mat-label>
          <mat-select
            value="admin_product_dropdown_form_group['pack'].value"
            formControlName="pack"
            multiple
          >
            <mat-option (click)="toggleSelection(b,'pack',1)" *ngFor="let b of packs" [value]="b">{{ b }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.pack_type_revised }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
  <mat-paginator
    *ngIf="admin_sku_data && admin_sku_data.length > 0"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    hidePageSize="true"
    [length]="filtered_admin_sku_data.length"
    (page)="paginationChange($event)"
    class="admin-sku-paginator"
  >
  </mat-paginator>
  <app-loader
    [is_show_loader]="(loader | async)! || is_show_loader"
  ></app-loader>
</div>
